import { render, staticRenderFns } from "./DateRangeWidget.vue?vue&type=template&id=b973e580&lang=pug&"
import script from "./DateRangeWidget.vue?vue&type=script&lang=js&"
export * from "./DateRangeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports